import RouterPage from './pages/RouterPage';
import * as React from 'react'
import { ThemeProvider } from 'styled-components';
global.purchaseAmount = 0
global.advancedAnalytics = {}
function rtl() {
  return (
    <div></div>
  )
}
function topMenu() {
  return (
    <div />
  )
}
const darkMode = false;

const VIKTOR_IP = 'http://192.168.1.22'
const MASA_IP = 'http://192.168.0.55'
const SERVER = 'https://blububl.com'
const VIKTOR_HN = 'http://192.168.1.20'
const VIKTOR_FON = 'http://172.20.10.5'
global.SERVIP = SERVER // 'http://127.0.0.1' // 
function App() {
  return (
    <RouterPage />
  );
}

export default App;
